const CommunicationChannel = {
  // Sms: "978883ce-1811-4ec0-a968-b5121c8c879e",
  // Push: "12e87983-5e94-4fdb-ac0a-348933ca85d0",
  Email: "6b11d3f0-1d46-418f-8afb-8a481b388c64",
  InnerNotification: "a9aabdad-840d-4b6f-bed9-960d748cbc9e"
};
const CommunicationChannelsArray = [
  // {
  // 	id: CommunicationChannel.Push,
  // 	name: "Push-уведомление",
  // 	lczKey: "lookups.communication_channels.push",
  // },
  {
    id: CommunicationChannel.Email,
    name: "Email",
    lczKey: "lookups.communication_channels.email"
  },
  {
    id: CommunicationChannel.InnerNotification,
    name: "Внутреннее уведомление",
    lczKey: "lookups.communication_channels.inner"
  }
];
export {
  CommunicationChannel,
  CommunicationChannelsArray
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29tbXVuaWNhdGlvbkNoYW5uZWxzLmpzIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RhbnRzL0NvbW11bmljYXRpb25DaGFubmVscy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgQ29tbXVuaWNhdGlvbkNoYW5uZWwgPSB7XG5cdC8vIFNtczogXCI5Nzg4ODNjZS0xODExLTRlYzAtYTk2OC1iNTEyMWM4Yzg3OWVcIixcblx0Ly8gUHVzaDogXCIxMmU4Nzk4My01ZTk0LTRmZGItYWMwYS0zNDg5MzNjYTg1ZDBcIixcblx0RW1haWw6IFwiNmIxMWQzZjAtMWQ0Ni00MThmLThhZmItOGE0ODFiMzg4YzY0XCIsXG5cdElubmVyTm90aWZpY2F0aW9uOiBcImE5YWFiZGFkLTg0MGQtNGI2Zi1iZWQ5LTk2MGQ3NDhjYmM5ZVwiLFxufTtcblxuZXhwb3J0IGNvbnN0IENvbW11bmljYXRpb25DaGFubmVsc0FycmF5ID0gW1xuXHQvLyB7XG5cdC8vIFx0aWQ6IENvbW11bmljYXRpb25DaGFubmVsLlB1c2gsXG5cdC8vIFx0bmFtZTogXCJQdXNoLdGD0LLQtdC00L7QvNC70LXQvdC40LVcIixcblx0Ly8gXHRsY3pLZXk6IFwibG9va3Vwcy5jb21tdW5pY2F0aW9uX2NoYW5uZWxzLnB1c2hcIixcblx0Ly8gfSxcblx0e1xuXHRcdGlkOiBDb21tdW5pY2F0aW9uQ2hhbm5lbC5FbWFpbCxcblx0XHRuYW1lOiBcIkVtYWlsXCIsXG5cdFx0bGN6S2V5OiBcImxvb2t1cHMuY29tbXVuaWNhdGlvbl9jaGFubmVscy5lbWFpbFwiLFxuXHR9LFxuXHR7XG5cdFx0aWQ6IENvbW11bmljYXRpb25DaGFubmVsLklubmVyTm90aWZpY2F0aW9uLFxuXHRcdG5hbWU6IFwi0JLQvdGD0YLRgNC10L3QvdC10LUg0YPQstC10LTQvtC80LvQtdC90LjQtVwiLFxuXHRcdGxjektleTogXCJsb29rdXBzLmNvbW11bmljYXRpb25fY2hhbm5lbHMuaW5uZXJcIixcblx0fSxcbl07XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQU8sTUFBTSx1QkFBdUI7QUFBQTtBQUFBO0FBQUEsRUFHbkMsT0FBTztBQUFBLEVBQ1AsbUJBQW1CO0FBQ3BCO0FBRU8sTUFBTSw2QkFBNkI7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsRUFNekM7QUFBQSxJQUNDLElBQUkscUJBQXFCO0FBQUEsSUFDekIsTUFBTTtBQUFBLElBQ04sUUFBUTtBQUFBLEVBQ1Q7QUFBQSxFQUNBO0FBQUEsSUFDQyxJQUFJLHFCQUFxQjtBQUFBLElBQ3pCLE1BQU07QUFBQSxJQUNOLFFBQVE7QUFBQSxFQUFBO0FBRVY7In0=
